import { Component, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Clinic } from '../../data/models/Clinic';
import { ClinicContentBlock } from '../../data/models/ClinicContentBlock';
import { environment } from '../../../environments/environment';
import { API } from '../../data/api';

@Component({
  selector: 'app-preview',
  imports: [NgTemplateOutlet, MatIconModule, MatTooltipModule],
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.scss'
})
export class PreviewComponent {
  @Input() clinic: Clinic | null = null
  @Input() blocks: ClinicContentBlock[] = []

  /** Im Preview lokal eingeklappte Block-Keys (nur UI-State, nicht persistent) */
  private expandedCollapsibleBlocks = new Set<string>()

  /** Tracked welche Media-URLs beim Laden gescheitert sind — pro Pfad */
  imageErrors = new Map<string, string>()

  onImageError(path: string | null, event: Event): void {
    if (!path) return
    const url = this.getMediaUrl(path)
    this.imageErrors.set(path, url)
    console.warn('[preview] Image load failed', { path, url, event })
  }

  hasImageError(path: string | null): boolean {
    return !!path && this.imageErrors.has(path)
  }

  imageErrorUrl(path: string | null): string {
    return path ? this.imageErrors.get(path) || '' : ''
  }

  get publishedBlocks(): ClinicContentBlock[] {
    return this.blocks
      .filter(b => b.is_published)
      .sort((a, b) => a.order - b.order)
  }

  isExpanded(block: ClinicContentBlock): boolean {
    return this.expandedCollapsibleBlocks.has(block.key)
  }

  toggleExpanded(block: ClinicContentBlock, event?: Event): void {
    event?.stopPropagation()
    if (this.expandedCollapsibleBlocks.has(block.key)) {
      this.expandedCollapsibleBlocks.delete(block.key)
    } else {
      this.expandedCollapsibleBlocks.add(block.key)
    }
  }

  collapsibleHeader(block: ClinicContentBlock): string {
    if (block.title) return block.title
    switch (block.block_type.name) {
      case 'logo': return 'Logo'
      case 'address': return 'Adresse'
      case 'phone': return 'Telefon'
      case 'website': return 'Webseite'
      case 'text': return 'Information'
      case 'video': return 'Video'
      case 'image': return 'Bild'
      case 'button': return block.button_text || 'Link'
      case 'contact_person': return block.contact_name || 'Ansprechperson'
      default: return 'Mehr anzeigen'
    }
  }

  getMediaUrl(path: string | null): string {
    if (!path) return ''
    if (path.startsWith('blob:')) return path
    return `${environment.url}/${environment.backendVersion}/${API.clinicMedia(path)}`
  }
}
